import React from 'react';

import { Partner } from '../../auth/accessToken/Partner';
import { useTranslation } from 'react-i18next';
import { AppBarIconLink } from '.';

interface AppBarPartnerLinkProps extends React.DOMAttributes<HTMLSpanElement> {
    accountId: string;
}

const AppBarPartnerLink = (
    {
        accountId,
    }: AppBarPartnerLinkProps
) => {
    const { t } = useTranslation();
    return (
        <Partner>
            <AppBarIconLink
                to={`/${accountId}/sub-accounts`}
                icon="partner"
                title={t('app_bar.titles.partner_admin')}
            />
        </Partner>
    );
};

export default AppBarPartnerLink;
